/******************************************************************
Custom scripts for stripe checkouts
******************************************************************/

/* function to retrieve a stripe checkout session and refresh the page with the client secret */
function stripeCheckoutGo() {

    const validateEmail = (email) => {
        const emailRegex = /^[a-zA-Z0-9._-]+(?<!\.)@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        return emailRegex.test(email);
    };    

    //get form data
    const formData = serializeForm(document.getElementById('pr-stripe-checkout-form'));

    if(formData.email?.trim()?.length == 0) {
        document.querySelector(`#pr-stripe-checkout-form input[name="email"]`).classList.add("input-error");
        return false;
    }
    else if (!validateEmail(formData.email)) {
        document.querySelector(`#pr-stripe-checkout-form input[name="email"]`).classList.add("input-error");
        return false;
    }

    //document.querySelector(`#pr-stripe-checkout-form button`).innerHTML = "One moment...";
    document.querySelector(`#pr-stripe-checkout-form button`).disabled=true;
    document.querySelector(`#pr-stripe-checkout-error`).style.display = "none";

    initPRCheckout(formData);
    
    return false;
}

/* load Stripe checkout */
async function loadPRCheckout(secret) {
    
    const stripeKeyTesting = 'pk_test_ZBnOLC1sYyZwDrNEeqS6CnNb00ILhjgfiq', stripeKeyLive = 'pk_live_RCfvF6cejjvrgPPS79vbJvPJ00RBEO9ANg';
    const stripKey = stripeKeyLive;

    const fetchClientSecret = async () => {        
        return secret;
    };

    const stripe = Stripe(stripKey);
    const checkout = await stripe.initEmbeddedCheckout({fetchClientSecret});
    checkout.mount('#pr-stripe-checkout');
}

/* fetch stripe checkout secret */
async function initPRCheckout(formData) {

    //const orderManager = "https://jasproxy.ngrok.dev/checkouts-";
    const orderManager = "https://repatpro.projectrepat.com/checkouts-";

    try {        
        const checkoutSessionReq = await fetch(`${orderManager}init?ck=1`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
        });
        const checkoutSessionResponse = await checkoutSessionReq.json();
                
        if(checkoutSessionResponse.success) {
            document.getElementById("pr-stripe-checkout-form").style.display = "none";
            const landerPromo = document.getElementById("pr-stripe-lander-promo");
            if(landerPromo) {
                landerPromo.style.display = "none";
            }            
            loadPRCheckout(checkoutSessionResponse.secret);
            window.fbq('track', 'Lead');
            window.fbq('trackCustom', 'PR Stripe Checkout Lead');
        } else {
            throw new Error("Failed to create checkout session");
        } 
    } catch (error) {
        document.querySelector(`#pr-stripe-checkout-form button`).disabled=false;
        document.querySelector(`#pr-stripe-checkout-error`).style.display = "block";
    }
}